import { useState, useCallback, useEffect } from 'react';

import { useAppContext } from '../contextApi/context';
import { getReceiptsByArticleReport, getReceiptsByArticleReportTotalValue } from '../services/ReportsService';
import { exportReceiptsByArticleReport } from '../services/ExportService';
import TableContainer from '../components/table/TableContainer';
import { formatCurrency } from '../utils/numbers';
import { formatDate } from '../utils/dates';

const ReportReceiptsByArticle = () => {
    // ----- Context
    const { loggedUser } = useAppContext();

    // ----- State
    let [tableTotalValue, setTableTotalValue] = useState(null);

    // ----- API Fetch Actions
    const fetchTotalValueData = useCallback(
        async (filters = []) => {
            return await getReceiptsByArticleReportTotalValue(loggedUser.token, filters);
        },
        [loggedUser.token]
    );

    // ----- Hooks
    useEffect(() => {
        fetchTotalValueData().then((data) => {
            setTableTotalValue(data);
        });
    }, [fetchTotalValueData]);

    // ----- Actions
    const handleDataAfterFiltering = (filters) => {
        fetchTotalValueData(filters).then((data) => {
            setTableTotalValue(data);
        });
    };

    // ----- Constants
    const columns = [
        {
            name: 'Artículo',
            selector: (row) => row.article,
            sortable: true,
            sortField: 'article',
        },
        {
            name: 'Proveedor',
            selector: (row) => row.provider,
            sortable: true,
            sortField: 'provider',
        },
        {
            name: 'Cantidad',
            selector: (row) => row.amount,
        },
        {
            name: 'Precio promedio',
            selector: (row) => `₡${formatCurrency(row.averageValue)}`,
        },
        {
            name: 'Precio total',
            selector: (row) => `₡${formatCurrency(row.totalValue)}`,
            sortable: true,
            sortField: 'totalValue',
        },
        {
            name: 'Fecha de factura',
            selector: (row) => (row.eventDate ? formatDate(row.eventDate) : '--'),
        },
        {
            name: 'Número de factura',
            selector: (row) => row.invoice,
            sortable: true,
            sortField: 'invoice',
        },
    ];

    const filters = [
        {
            column: 'article',
            input: 'text',
            label: 'Artículo',
            operation: 'like',
            length: 50,
        },
        {
            column: 'internalCode',
            input: 'text',
            label: 'Código',
            operation: 'like',
            length: 10,
        },
        {
            column: 'brand',
            input: 'text',
            label: 'Marca',
            operation: 'like',
            length: 25,
        },
        {
            column: 'provider',
            input: 'text',
            label: 'Proveedor',
            operation: 'like',
            length: 50,
        },
        {
            column: 'eventDate',
            input: 'dates',
            label: 'Fecha de compra',
            operation: 'between',
        },
    ];

    const exportOptions = {
        handler: exportReceiptsByArticleReport,
    };

    // ----- Render
    return (
        <div className='container mt-5'>
            <h1 className='mb-5'>Reporte de Compras por Artículo</h1>

            <TableContainer
                afterFilteringHandler={handleDataAfterFiltering}
                columns={columns}
                fetchDataHandler={getReceiptsByArticleReport}
                updateTable={true}
                filters={filters}
                exportOptions={exportOptions}
                totalValue={tableTotalValue}
            />
        </div>
    );
};

export default ReportReceiptsByArticle;
